import React from 'react';
import { setCurrentView } from 'core/utils';
import { TwoStepAuthenticationTemplate } from 'themes/modules/membership/pages';
import { TwoStepAuthenticationViewStore } from 'modules/membership/stores';

@setCurrentView(rootStore => new TwoStepAuthenticationViewStore(rootStore), 'twoStepAuthenticationViewStore')
class TwoStepAuthentication extends React.Component {
	render() {
		return <TwoStepAuthenticationTemplate {...this.props} viewStore={this.props.twoStepAuthenticationViewStore} />;
	}
}

export default TwoStepAuthentication;
